import { render, staticRenderFns } from "./panel-admin.vue?vue&type=template&id=579c8c18&"
import script from "./panel-admin.vue?vue&type=script&lang=js&"
export * from "./panel-admin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports